// Enumerations from "External API Documentation for Peerapat" (21 Sep 2026).
// Values are the API's; labels are what staff see.

// The API exposes two lease templates. The machine type each is used for was
// read off the contracts already on the e-Contract UAT site (every LCT-001 is a
// Combi Oven agreement, every LCT-002 a floor-machine one). There is no
// dishwasher template there yet — confirm with e-Contract before using one.
export const CONTRACT_TYPES = [
  { value: 'LCT-001', labelTh: 'สัญญาเช่า แบบที่ 1', labelEn: 'Template 1', icon: 'bi-fire', hint: 'กลุ่ม KT · เครื่องครัว (Kitchen)' },
  { value: 'LCT-002', labelTh: 'สัญญาเช่า แบบที่ 2', labelEn: 'Template 2', icon: 'bi-droplet-half', hint: 'กลุ่ม HK · เครื่องขัด/ล้างพื้น (Floor machine)' }
];

// The Venio/NetSuite product group's two-letter prefix decides the template:
// KT-Rnn = Kitchen (เครื่องครัว) -> LCT-001, HK-Rnn = Floor machine -> LCT-002.
export const GROUP_PREFIX_CONTRACT_TYPE = { KT: 'LCT-001', HK: 'LCT-002' };

export const VAT_OPTIONS = [
  { value: '7', label: 'VAT 7%' },
  { value: '0', label: 'VAT 0%' },
  { value: 'non vat', label: 'ไม่มี VAT (non vat)' }
];

export const DOCUMENT_LANGUAGES = [
  { value: 'th', label: 'ไทย' },
  { value: 'en', label: 'English' }
];

export const INSPECTION_UNITS = [
  { value: 'month_per_time', label: 'เดือนต่อ 1 ครั้ง' },
  { value: 'week_per_time', label: 'สัปดาห์ต่อ 1 ครั้ง' },
  { value: 'day_per_time', label: 'วันต่อ 1 ครั้ง' },
  { value: 'year_per_time', label: 'ปีต่อ 1 ครั้ง' },
  { value: 'times_per_month', label: 'ครั้งต่อเดือน' },
  { value: 'times_per_week', label: 'ครั้งต่อสัปดาห์' },
  { value: 'times_per_day', label: 'ครั้งต่อวัน' },
  { value: 'times_per_year', label: 'ครั้งต่อปี' }
];

export const PARTY_TYPES = [
  { value: 'lessor', label: 'ผู้ให้เช่า' },
  { value: 'lessee', label: 'ผู้เช่า' },
  { value: 'lessor_witness', label: 'พยานผู้ให้เช่า' },
  { value: 'lessee_witness', label: 'พยานผู้เช่า' }
];

export const USER_TYPES = [
  { value: 'user', label: 'มีบัญชีใน e-Contract (ระบุอีเมล)' },
  { value: 'none user', label: 'ไม่มีบัญชี (กรอกข้อมูลบุคคล)' }
];

// Contract lifecycle ("Contract Status Values").
export const CONTRACT_STATUS = {
  awaiting: { label: 'รอรับงาน', tone: 'amber' },
  draft: { label: 'ฉบับร่าง', tone: 'gray' },
  pending: { label: 'รอดำเนินการ', tone: 'blue' },
  approved: { label: 'อนุมัติ', tone: 'green' },
  terminated: { label: 'ไม่อนุมัติ', tone: 'red' },
  expired: { label: 'หมดอายุ', tone: 'gray' },
  cancelled: { label: 'ยกเลิกสัญญา', tone: 'red' }
};

export const LEVEL_STATUS_LABEL = {
  not_started: 'ยังไม่เริ่ม',
  pending: 'รอดำเนินการ',
  canceled: 'ยกเลิก',
  cancelled: 'ยกเลิก',
  approved: 'อนุมัติแล้ว',
  terminated: 'ไม่อนุมัติ'
};

export const MEMBER_STATUS_LABEL = {
  draft: 'ฉบับร่าง',
  pending: 'รอดำเนินการ',
  canceled: 'ยกเลิก',
  cancelled: 'ยกเลิก',
  expired: 'หมดอายุ',
  approved: 'อนุมัติแล้ว',
  terminated: 'ไม่อนุมัติ'
};

// Peerapat's own registered details, taken from the master contract templates
// (printed identically in every contract). Left editable in case they change.
export const LESSOR_DEFAULTS = {
  lessor_company_name: 'บริษัท พีรพัฒน์ เทคโนโลยี จำกัด (มหาชน)',
  lessor_company_address: '406 ถนนรัชดาภิเษก แขวงสามเสนนอก เขตห้วยขวาง กรุงเทพมหานคร 10310',
  lessor_company_phone_number: '022901200',
  lessor_signer_full_name: 'นายนวพล แย้มจั่น และ นางสาวอภิสรา เกตุนุติ',
  lessor_signer_job_position: ''
};

// `additional_terms` is sanitised by e-Contract down to exactly these tags,
// with every attribute stripped.
export const ALLOWED_TERMS_TAGS = ['h1', 'h2', 'h3', 'h4', 'p', 'ol', 'ul', 'li', 'strong', 'b', 'em', 'i', 'u', 'br', 'span', 'div'];
